import { render, staticRenderFns } from "./expertDetail.vue?vue&type=template&id=f44e3f4a&scoped=true&"
import script from "./expertDetail.vue?vue&type=script&lang=js&"
export * from "./expertDetail.vue?vue&type=script&lang=js&"
import style0 from "./expertDetail.vue?vue&type=style&index=0&id=f44e3f4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44e3f4a",
  null
  
)

export default component.exports